import { Controller } from '@hotwired/stimulus'

// Shown after returning from Stripe Checkout while the activating webhook
// is still in flight. Reloads the billing page on an interval until the
// subscription appears (the server then renders the active panel instead
// of this one), giving up after a few attempts and leaving the manual
// refresh link.
export default class extends Controller {
  static targets = ['refresh']
  static values = {
    interval: { type: Number, default: 4000 },
    maxAttempts: { type: Number, default: 10 },
  }

  connect() {
    this.attempts = 0
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    this.stop()
  }

  poll() {
    this.attempts += 1
    if (this.attempts >= this.maxAttemptsValue) {
      this.stop()
      return
    }
    this.reload()
  }

  reload() {
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: 'replace' })
    } else {
      window.location.reload()
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
